/**
 * @flow
 * @format
 */

import _ from 'lodash';
import { isBrowserIE } from '~/utils';
import { app } from '~/routines';
import designRoutines from '~/routines/design';

/**
 * Middleware to handle scroll actions
 * @param {ReduxStore} store
 * @param {*} next
 * @param {Action} action
 */
export const scrollMiddleware = () => (next: any) => (action: any) => {
  if (action.type === app.scrollToTop.toString()) {
    setTimeout(() => window.scrollTo(0, 0), 100);
  }

  // dumb
  if (action.type === app.scrollToTop.toString()) {
    if (isBrowserIE()) {
      setTimeout(() => {
        /**
         * IE11 doesn't support fixed table headers like other modern browers
         * so we need to use the jquery plugin to add it at runtime.
         * This is the only plugin that worked and I didn't want to rewrite it
         * in vanilla so we're loading jquery and this plugin only in IE browers.
         */
        const tables = window.jQuery(process.env.REACT_APP_IE11_FIXED_TABLES);

        tables.floatThead({
          position: 'absolute',
          autoReflow: true,
          scrollContainer: true,
        });

        setTimeout(() => {
          // Fixes the 15px right offset calculation error in IE
          window
            .jQuery('div.floatThead-container')
            .css('overflow-x', 'visible');
        }, 0);
      }, 150);
    }
  }

  return next(action);
};

/**
 * Middleware to handle renaming fields where needed
 * @param {ReduxStore} store
 */
// eslint-disable-next-line no-unused-vars
export const messageForHandler = (store: any) => {
  const fieldRemap = {
    SuitableInductors: 'IndPNsel',
    Pkgs_FET0: 'Pkgs_FET',

    // Re-route No parts found meeting thermal requirements
    pkgs_Diode0: 'DiodesVIPTgood',

    // Re-route no parts found errors to the select tables
    diode_sel: 'Losscomp_diode',
    PN_list_diode: 'Losscomp_diode',
    PN_sel_fet: 'Losscomp_FET',
    PN_list_fet: 'Losscomp_FET',
  };

  return (next: any) => (action: any) => {
    const messageFor: string = _.get(action, ['payload', 'messageFor']);
    const content: string = _.get(action, ['payload', 'content']);

    if (messageFor) {
      const field = fieldRemap[messageFor] || messageFor;
      action = _.set(action, ['payload', 'messageFor'], field); // eslint-disable-line no-param-reassign
      action = _.set(action, ['payload', 'content'], content); // eslint-disable-line no-param-reassign
    }

    return next(action);
  };
};

export const modalOpenHelper = (store: any) => (next: any) => (action: any) => {
  if (
    action.type === designRoutines.copyDesign.TRIGGER ||
    action.type === designRoutines.copyDesign.SUCCESS ||
    action.type === designRoutines.copyDesign.FULFILL ||
    action.type === designRoutines.copyDesign.REQUEST
  ) {
    // $FlowIgnore
    const isInModal = store.getState().modals.modalType !== null;
    action = _.set(action, ['payload', 'fromModal'], isInModal); // eslint-disable-line no-param-reassign
  }
  next(action);
};

export default {
  messageForHandler,
  scrollMiddleware,
  modalOpenHelper,
};



// WEBPACK FOOTER //
// ./src/middleware/index.js